/* global ga */

function init() {
    sendGoogleAnalyticsEventOnReferencesFirstMinuteCardClick();
    sendGoogleAnalyticsEventOnReferencesSpringDiscountCardClick();
    sendGoogleAnalyticsEventOnReferencesSummerDiscountCardClick();
    sendGoogleAnalyticsEventOnReferencesAutumnDiscountCardClick();
    sendGoogleAnalyticsEventOnReferencesWinterDiscountCardClick();
    sendGoogleAnalyticsEventOnLocationPrivateSearch();
    sendGoogleAnalyticsEventOnReferencesNearBeachCardClick();
    sendGoogleAnalyticsEventOnReferencesFamilyFriendlyCardClick();
    sendGoogleAnalyticsEventOnReferencesAllDiscountsCardClick();
    sendGoogleAnalyticsEventOnReferencesRobinsonCardClick();
    sendGoogleAnalyticsEventOnTopDestinationsClick();
    sendGoogleAnalyticsEventOnGuideArticleClick();
    sendGoogleAnalyticsEventOnBlogArticleClick();
    sendGoogleAnalyticsEventOnCompanyInfoSatisffiedGuestsClick();
    sendGoogleAnalyticsEventOnCompanyInfoLanguagesWeSpokeClick();
    sendGoogleAnalyticsEventOnCompanyInfoApartmentsOfferClick();
    sendGoogleAnalyticsEventOnCompanyInfoYearsOfExperienceClick();
    sendGoogleAnalyticsEventOnProvidersBannerClick();
    sendGoogleAnalyticsEventOnLoyaltyBannerClick();
    sendGoogleAnalyticsEventOnFirstTimeBannerClick();
}

function sendGoogleAnalyticsEventOnReferencesFirstMinuteCardClick() {
    document.getElementById('referencesFirstMinuteDiscount').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Privatni smještaj', 'First minute');
        }
    });
}

function sendGoogleAnalyticsEventOnReferencesSpringDiscountCardClick() {
    document.getElementById('referencesSpringDiscount').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Privatni smještaj', 'Proljetni popust');
        }
    });
}

function sendGoogleAnalyticsEventOnReferencesSummerDiscountCardClick() {
    document.getElementById('referencesSummerDiscount').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Privatni smještaj', 'Ljetni popust');
        }
    });
}

function sendGoogleAnalyticsEventOnReferencesAutumnDiscountCardClick() {
    document.getElementById('referencesAutumnDiscount').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Privatni smještaj', 'Jesenski popust');
        }
    });
}

function sendGoogleAnalyticsEventOnReferencesWinterDiscountCardClick() {
    document.getElementById('referencesWinterDiscount').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Privatni smještaj', 'Zimski popust');
        }
    });
}

function sendGoogleAnalyticsEventOnLocationPrivateSearch() {
    document.getElementById('homePagePrivateSearch').addEventListener('submit', () => {
        const locationName = document.getElementById('SearchPrivateFilterForm_location').value;
        if (googleAnalyticsExists() && locationName !== '') {
            ga('send', 'event', 'Naslovnica', 'Traži_simple', locationName);
        }
    });
}

function sendGoogleAnalyticsEventOnReferencesNearBeachCardClick() {
    document.getElementById('referencesNearBeach').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Privatni smeštaj', 'Smještaj uz plažu');
        }
    });
}

function sendGoogleAnalyticsEventOnReferencesFamilyFriendlyCardClick() {
    document.getElementById('referencesFamilyFriendly').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Privatni smeštaj', 'Obiteljski odmor');
        }
    });
}

function sendGoogleAnalyticsEventOnReferencesAllDiscountsCardClick() {
    document.getElementById('referencesAllDiscounts').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Privatni smeštaj', 'Popusti');
        }
    });
}

function sendGoogleAnalyticsEventOnReferencesRobinsonCardClick() {
    document.getElementById('referencesRobinson').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Privatni smeštaj', 'Robinzonski objekti');
        }
    });
}

function sendGoogleAnalyticsEventOnTopDestinationsClick() {
    document.querySelectorAll('#topDestinations li').forEach((item) => {
        item.addEventListener('click', function sendGAEvent() {
            const destinationName = this.querySelector('.js-destinationTitle').textContent;
            if (googleAnalyticsExists() && destinationName !== '') {
                ga('send', 'event', 'Naslovnica', 'Popularne rivijere', destinationName);
            }
        });
    });
}

function sendGoogleAnalyticsEventOnGuideArticleClick() {
    document.querySelectorAll('#guideAndBlogArticles .js-guideArticle').forEach((item) => {
        item.addEventListener('click', () => {
            if (googleAnalyticsExists()) {
                ga('send', 'event', 'Naslovnica', 'Vodič', 'Članak slika');
            }
        });
    });
}

function sendGoogleAnalyticsEventOnBlogArticleClick() {
    document.querySelectorAll('#guideAndBlogArticles .js-blogArticle').forEach((item) => {
        item.addEventListener('click', () => {
            if (googleAnalyticsExists()) {
                ga('send', 'event', 'Naslovnica', 'Blog', 'Članak slika');
            }
        });
    });
}

function sendGoogleAnalyticsEventOnCompanyInfoSatisffiedGuestsClick() {
    document.getElementById('satisffiedGuests').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Guestbook');
        }
    });
}

function sendGoogleAnalyticsEventOnCompanyInfoLanguagesWeSpokeClick() {
    document.getElementById('languagesWeSpoke').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Team');
        }
    });
}

function sendGoogleAnalyticsEventOnCompanyInfoApartmentsOfferClick() {
    document.getElementById('ourApartmentsOffer').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'Accommodation');
        }
    });
}

function sendGoogleAnalyticsEventOnCompanyInfoYearsOfExperienceClick() {
    document.getElementById('yearsOfExperience').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'About');
        }
    });
}

// Potrebno provjeriti postojanje elementa jer se ne nudi na svim lokalima
function sendGoogleAnalyticsEventOnProvidersBannerClick() {
    const providersBanner = document.getElementById('providersBanner');
    if (providersBanner !== null) {
        providersBanner.addEventListener('click', () => {
            if (googleAnalyticsExists()) {
                ga('send', 'event', 'Naslovnica', 'Iznajmljivači', 'banner');
            }
        });
    }
}

// Potrebno provjeriti postojanje elementa jer se ne nudi na svim lokalima
function sendGoogleAnalyticsEventOnLoyaltyBannerClick() {
    const loyaltyBanner = document.getElementById('loyaltyBanner');
    if (loyaltyBanner !== null) {
        loyaltyBanner.addEventListener('click', () => {
            if (googleAnalyticsExists()) {
                ga('send', 'event', 'Naslovnica', 'Loyalty');
            }
        });
    }
}

function sendGoogleAnalyticsEventOnFirstTimeBannerClick() {
    document.getElementById('firstTimeBanner').addEventListener('click', () => {
        if (googleAnalyticsExists()) {
            ga('send', 'event', 'Naslovnica', 'FirstTime');
        }
    });
}

function googleAnalyticsExists() {
    return typeof ga !== 'undefined';
}

export default function initGoogleAnalyticsEvents() {
    init();
}
